// extracted by mini-css-extract-plugin
export default {"box":"box_box__tnn3j"};